import { useLocation } from 'react-router';
import queryString from 'query-string';

export default useChartDipsParam;

/**
 * This hook retrieves the query parameter "chartDips" from the URL and
 * returns 'false' if the chart dips algorithm (removeTrendOutliers) should be turned off (?chartDips=off).
 */
function useChartDipsParam(): boolean {
  const location = useLocation();
  const params = queryString.parse(location.search);

  return !(params.chartDips === 'off');
}
